
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propiedades",
      function () {
        return require("private-next-pages/propiedades/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/propiedades"])
      });
    }
  